/* eslint-disable quotes */
// eslint-disable-next-line quotes
import headerSticky from "../plugins/headerSticky";
// eslint-disable-next-line quotes
import hcOffcanvasNav from "hc-offcanvas-nav";

export default {
  init() {
    // JavaScript to be fired on all pages

    headerSticky();

    // eslint-disable-next-line quotes
    new hcOffcanvasNav("#main-nav", {
      disableAt: 1279,
      // disableAt: false,
      width: 377,
      // eslint-disable-next-line quotes
      customToggle: ".toggle",
      // eslint-disable-next-line quotes
      levelOpen: "expand",
      // navTitle: {},
      // levelTitles: true,
      // levelTitleAsBack: true,
      // closeOpenLevels: true,
      // closeActiveLevel: true,
      disableBody: true,
      // eslint-disable-next-line quotes
      position: "right",
      // eslint-disable-next-line quotes
      labelBack: "กลับสู่เมนูหลัก",
      // eslint-disable-next-line quotes
      // pushContent: ".wrap",
    });

    $(".btn-book").on("click", function () {
      $("body").addClass("open-search");
    });

    $(".backdroup").on("click", function () {
      $("body").removeClass("open-search");
    });

    $(".form_checkrate").on("submit", function (e) {
      e.preventDefault();

      var checkin = $(".check-in").val();
      var checkout = $(".check-out").val();
      var adults = $(".adults").val();
      var children = $(".children").val();

      var fullUrl =
        "https://book-directonline.com/properties/blistonsuwanparkdirect?locale=en";
      var finalUrl =
        fullUrl +
        "&items[0][adults]=" +
        adults +
        "&items[0][children]=" +
        children +
        "&checkInDate=" +
        checkin +
        "&checkOutDate=" +
        checkout;

      if (checkin && checkout && adults != "") {
        window.location.href = finalUrl;
        $(this).reset();
      } else {
        if (!$(".error-mass").length) {
          $(".form_checkrate").prepend(
            "<div class='error-mass'>Please fill out the information completely.</div>"
          );
        }

        if (checkin == "") {
          $(".check-in").addClass("error");
        } else {
          $(".check-in").removeClass("error");
        }
        if (checkout == "") {
          $(".check-out").addClass("error");
        } else {
          $(".check-out").removeClass("error");
        }
        if (adults == "") {
          $(".adults").addClass("error");
        } else {
          $(".adults").removeClass("error");
        }
      }
    });

    $(".check-out").datepicker({
      showOtherMonths: true,
      selectOtherMonths: true,
      dateFormat: "yy-mm-dd",
    });

    $(".check-in").datepicker({
      showOtherMonths: true,
      selectOtherMonths: true,
      dateFormat: "yy/mm/dd",
      minDate: 0,
      onSelect: function (date) {
        var date1 = $(".check-in").datepicker("getDate");
        // eslint-disable-next-line no-redeclare
        var date = new Date(Date.parse(date1));
        date.setDate(date.getDate() + 1);
        var newDate = date.toDateString();
        newDate = new Date(Date.parse(newDate));
        $(".check-out").datepicker("option", "minDate", newDate);
      },
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js